import { Head, router, useForm } from "@inertiajs/react"

import PartnerUserForm from "@/components/partners/partner-user-form"
import RecordForm from "@/components/record-form"
import RecordPageHeader from "@/components/ui/record-page-header"
import AdminLayout from "@/layouts/admin-layout"
import { adminPartnerUserPath, adminPartnerUsersPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

interface Partner {
  uid: string
  name: string
}

interface PartnerUserData {
  uid: string
  name: string
  email: string
  partner_uid: string
  avatar_url: string | null
  partner: Partner | null
}

export default function EditPartnerUser({
  partner_user,
  partners,
}: {
  partner_user: PartnerUserData
  partners: Partner[]
}) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Partner Users", href: adminPartnerUsersPath() },
    {
      title: partner_user.name || partner_user.email,
      href: adminPartnerUserPath({ id: partner_user.uid }),
    },
    { title: "Edit", href: "#" },
  ]

  const { data, setData, patch, processing, errors } = useForm({
    partner_user: {
      name: partner_user.name ?? "",
      email: partner_user.email,
      partner_uid: partner_user.partner_uid,
      avatar: null as File | null,
      send_welcome_email: "0",
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    patch(adminPartnerUserPath({ id: partner_user.uid }), {
      forceFormData: true,
    })
  }

  function handleCancel() {
    router.visit(adminPartnerUserPath({ id: partner_user.uid }))
  }

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit ${partner_user.name || partner_user.email}`} />
      <div className="flex h-full w-full flex-col gap-6 p-4">
        <div className="mx-auto w-full max-w-2xl">
          <RecordPageHeader title={partner_user.name || partner_user.email} />
        </div>
        <RecordForm
          submitLabel="Save"
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          processing={processing}
        >
          <PartnerUserForm
            data={data}
            setData={setData}
            errors={errors}
            partners={partners}
            mode="edit"
          />
        </RecordForm>
      </div>
    </AdminLayout>
  )
}
